<span class="chip ls-m1" [style.background-color]="backgroundColor" [style.color]="color" (click)="bodyClick.emit()">
  <ng-content />
  <i class="ph ph-x" (click)="closeClick.emit()"></i>
</span>
